import { Stack, Typography } from '@mui/material';
import * as React from 'react';
import { useSelectionContext, useYearContext, NO_COMPARISON } from '../../context';
import { lloydConstants } from '../../Constants';
import { scaleFor } from '../../scales';

/**
 * Key for the two colour modes that carry something size does not already say.
 * A continuous colour scale with no legend is decoration, not encoding.
 */
const ScaleLegend = () => {
	const { colorBy, colourBlindSafe } = useSelectionContext();
	const { comparisonYear } = useYearContext();
	const scales = scaleFor(colourBlindSafe);

	const modes = lloydConstants.colorBy;
	const isChange = colorBy === modes[3];
	const isPrecision = colorBy === modes[4];

	if (!isChange && !isPrecision) return null;

	const stops = isChange
		? [
				[-5, '−5 or worse'],
				[-2.5, '−2.5'],
				[0, 'No change'],
				[2.5, '+2.5'],
				[5, '+5 or better'],
		  ]
		: [
				[6, '±6'],
				[4, '±4'],
				[3, '±3'],
				[2, '±2'],
				[1, '±1 or better'],
		  ];

	const title = isChange
		? comparisonYear === NO_COMPARISON
			? 'Change — pick a comparison wave'
			: `Change since ${comparisonYear}, index points`
		: '95% margin of error';

	const colorSize = 16;

	return (
		<Stack
			spacing={{ xs: '12px', md: '60px' }}
			sx={{ position: 'absolute', bottom: 20, left: 20 }}
			direction={'row'}
			alignItems={'center'}
			flexWrap={'wrap'}
			rowGap={'8px'}
			maxWidth={'calc(100% - 40px)'}
		>
			<Typography fontWeight={500}>{title}</Typography>
			<Stack spacing={{ xs: 1.5, md: 3 }} alignItems={'center'} direction={'row'} flexWrap={'wrap'} rowGap={'6px'} flexShrink={0}>
				{stops.map(([value, label]) => (
					<Stack direction={'row'} alignItems={'center'} spacing={1} key={label}>
						<svg
							width={colorSize + 2}
							height={colorSize + 2}
							fill={isChange ? scales.change(value) : scales.precision(value)}
						>
							<circle cx={colorSize / 2 + 1} cy={colorSize / 2 + 1} r={colorSize / 2} stroke={'black'} />
						</svg>
						<Typography
							variant={'body2'}
							fontWeight={500}
							sx={{ marginLeft: '4px !important', paddingTop: 0 }}
						>
							{label}
						</Typography>
					</Stack>
				))}
			</Stack>
		</Stack>
	);
};

export default ScaleLegend;
